import { useState } from 'react'
import IndividualDonations from './IndividualDonations'
import DonationsByDonor from './DonationsByDonor'

export default function TabContainer() {
  const [activeTab, setActiveTab] = useState('individualDonations')

  return (
    <div id="tabContainer">
      <div className="flex border-b border-secondary">
        <button 
          className={`tablinks py-2 px-4 text-secondary hover:text-primary focus:outline-none ${activeTab === 'individualDonations' ? 'bg-gray-200 text-gray-800' : ''}`} 
          onClick={() => setActiveTab('individualDonations')}
        >
          Individual Donations
        </button>
        <button 
          className={`tablinks py-2 px-4 text-secondary hover:text-primary focus:outline-none ${activeTab === 'donationsByDonor' ? 'bg-gray-200 text-gray-800' : ''}`} 
          onClick={() => setActiveTab('donationsByDonor')}
        >
          Donations by Donor
        </button>
      </div>

      <div id="individualDonations" className={`tabcontent p-4 ${activeTab === 'individualDonations' ? '' : 'hidden'}`}>
        <IndividualDonations />
      </div>

      <div id="donationsByDonor" className={`tabcontent p-4 ${activeTab === 'donationsByDonor' ? '' : 'hidden'}`}>
        <DonationsByDonor />
      </div>
    </div>
  )
}

